export const PARTNERS = {
    FETCH_PARTNERS: {
        MAIN: 'FETCH_PARTNERS',
        SUCCESS: 'FETCH_PARTNERS_SUCCESS',
        FAILURE: 'FETCH_PARTNERS_FAILURE'
    },

};
